export default __webpack_public_path__ + "static/media/connectivity-Header-2k.3225c7af.jpg";